"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.GroupVisibility = exports.Group = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GroupActionButtonsV = _interopRequireDefault(require("./GroupActionButtonsV2"));

var _GroupModerators = _interopRequireDefault(require("./GroupModerators"));

var _GroupModerationWidget = _interopRequireDefault(require("./GroupModerationWidget"));

var _GroupMembersWidget = _interopRequireDefault(require("./GroupMembersWidget"));

var _GroupInformation = _interopRequireDefault(require("./GroupInformation"));

var _index = _interopRequireDefault(require("./../Navigation/widget-featured-topics/index.sync"));

var _classnames = _interopRequireDefault(require("classnames"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _GroupJoin = _interopRequireDefault(require("@insided/deprecated-preact-components/groups-destination/GroupJoin"));

var _Group = require("@insided/deprecated-preact-components/groups-destination/Group");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-detail';
exports.cssAnchorName = cssAnchorName;
var GroupVisibility;
exports.GroupVisibility = GroupVisibility;

(function (GroupVisibility) {
  GroupVisibility["Public"] = "public";
  GroupVisibility["Private"] = "private";
  GroupVisibility["Hidden"] = "hidden";
})(GroupVisibility || (exports.GroupVisibility = GroupVisibility = {}));

var Group = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Group, _Component);

  var _super = _createSuper(Group);

  function Group() {
    var _this;

    (0, _classCallCheck2.default)(this, Group);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      userJoined: _this.props.isCurrentUserMember,
      isLoading: false,
      requestSent: _this.props.membershipStatus === 'requested',
      userSubscribed: true,
      invite: (0, _Group.getInviteState)(_this.props.inviteStatus),
      curatedContent: _this.props.group.category.curatedContent
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "joinGroup", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(onSuccess) {
        var _this$props$group, _this$props$group2;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _Group.joinGroupAction)({
                  groupId: (_this$props$group = _this.props.group) === null || _this$props$group === void 0 ? void 0 : _this$props$group.id,
                  csrfToken: _this.props.csrfToken,
                  isPrivateGroup: ((_this$props$group2 = _this.props.group) === null || _this$props$group2 === void 0 ? void 0 : _this$props$group2.visibility) === GroupVisibility.Private,
                  setState: function setState(state) {
                    _this.setState(state);
                  },
                  onLoadSuccess: onSuccess
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "leaveGroup", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props$group3;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _Group.leaveGroupAction)((_this$props$group3 = _this.props.group) === null || _this$props$group3 === void 0 ? void 0 : _this$props$group3.id, _this.props.csrfToken, function (state) {
                _this.setState(state);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subscribe", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$props$group4;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _Group.subscribeAction)((_this$props$group4 = _this.props.group) === null || _this$props$group4 === void 0 ? void 0 : _this$props$group4.id, _this.props.csrfToken, function (state) {
                _this.setState(state);
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unsubscribe", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$props$group5;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _Group.unsubscribeAction)((_this$props$group5 = _this.props.group) === null || _this$props$group5 === void 0 ? void 0 : _this$props$group5.id, _this.props.csrfToken, function (state) {
                _this.setState(state);
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "requestJoin", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.joinGroup(function () {
                _this.setState({
                  requestSent: true
                });
              });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onManageGroupClick", function () {
      var _this$props$group6;

      window.location.href = (0, _absoluteUrlRuntime.resolveUrl)("/groups/".concat((_this$props$group6 = _this.props.group) === null || _this$props$group6 === void 0 ? void 0 : _this$props$group6.id, "/moderation?view=members"));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveTopics", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(topics, title) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this.setState({
                  curatedContent: {
                    title: title,
                    curatedTopics: topics
                  }
                });

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x2, _x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(Group, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var _this$props$group7,
            _this2 = this;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.props.isCurrentUserMember) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.next = 4;
                return (0, _Group.checkUserSubscribed)((_this$props$group7 = this.props.group) === null || _this$props$group7 === void 0 ? void 0 : _this$props$group7.id, function (state) {
                  _this2.setState(state);
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          canSee = _this$props.canSee,
          group = _this$props.group,
          topics = _this$props.topics,
          attachmentCdn = _this$props.attachmentCdn,
          featuredTopics = _this$props.featuredTopics,
          _this$props$allProduc = _this$props.allProductAreas,
          allProductAreas = _this$props$allProduc === void 0 ? [] : _this$props$allProduc,
          totalPagesCount = _this$props.totalPagesCount,
          currentPage = _this$props.currentPage,
          isCurrentUserModerator = _this$props.isCurrentUserModerator;
      var _this$state = this.state,
          userJoined = _this$state.userJoined,
          userSubscribed = _this$state.userSubscribed,
          isLoading = _this$state.isLoading,
          requestSent = _this$state.requestSent,
          invite = _this$state.invite,
          curatedContent = _this$state.curatedContent;
      return (0, _preact.h)("div", {
        className: "group-detail-wrapper",
        "data-bounded-context": "Groups",
        "data-entity": "group-details"
      }, invite !== null ? (0, _preact.h)(_message.default, {
        variant: invite.type,
        onDismiss: function onDismiss() {
          return _this3.setState({
            invite: null
          });
        },
        timer: invite.type !== 'error' ? 5000 : undefined
      }, (0, _preact.h)(_phrase.default, {
        p: invite.message,
        count: {
          g: (group === null || group === void 0 ? void 0 : group.name) || ''
        }
      })) : null, this.props.inviteStatus === 'fail:guest-user' ? (0, _preact.h)(_GroupJoin.default, {
        groupTitle: this.props.group.name,
        groupId: this.props.group.id,
        token: this.props.inviteToken
      }) : null, canSee && (0, _preact.h)("div", {
        className: "group-featured-topics-container"
      }, (0, _preact.h)(_GroupActionButtonsV.default, {
        joinGroup: this.joinGroup,
        leaveGroup: this.leaveGroup,
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
        onManageGroupClick: this.onManageGroupClick,
        isLoading: isLoading,
        isUserMember: userJoined,
        isUserSubscribed: userSubscribed,
        isCurrentUserModerator: isCurrentUserModerator,
        groupId: group.id,
        groupTitle: group.name,
        curatedContentTitle: curatedContent.title,
        curatedContentTopics: featuredTopics,
        onSaveTopics: this.onSaveTopics,
        communityLocale: this.props.communityLocale
      }), (0, _preact.h)(_GroupMembersWidget.default, {
        group: group
      }), (0, _preact.h)(_index.default, {
        featuredTopics: featuredTopics,
        allProductAreas: allProductAreas,
        config: {
          title: curatedContent.title,
          buttonURL: '',
          buttonLabel: '',
          subtitle: '',
          selectedDisplayViewPreference: 'card',
          backgroundColor: '',
          firstTopicsNumber: 0,
          topics: curatedContent.curatedTopics
        }
      })), (0, _preact.h)("div", {
        className: "sitewidth group-detail"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('col', 'col--main', 'has--side', 'qa-div-main')
      }, (0, _preact.h)(_Group.TopicsList, {
        canSee: canSee,
        topics: topics,
        attachmentCdn: attachmentCdn,
        isCurrentUserModerator: isCurrentUserModerator,
        requestJoin: this.requestJoin,
        isLoading: isLoading,
        requestSent: requestSent,
        totalPagesCount: totalPagesCount,
        currentPage: currentPage
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('col', 'col--side', 'Sidebarmodule', 'qa-div-sidebar')
      }, (0, _preact.h)("div", null, canSee && isCurrentUserModerator ? (0, _preact.h)("div", {
        className: "group-detail-info group-detail-info--moderation"
      }, (0, _preact.h)(_GroupModerationWidget.default, {
        group: group
      })) : null, (0, _preact.h)("div", {
        className: "group-detail-info group-detail-info--information"
      }, (0, _preact.h)(_GroupInformation.default, {
        group: group
      })), canSee && !requestSent ? (0, _preact.h)("div", {
        className: "group-detail-info"
      }, (0, _preact.h)(_GroupModerators.default, {
        group: group
      })) : null))));
    }
  }]);
  return Group;
}(_preact.Component);

exports.Group = Group;
var _default = Group;
exports.default = _default;